export const MIN_PASSWORD_LENGTH = 6;

export function getPasswordError(password, confirmPassword) {
  if (!password?.trim()) return 'Password is required.';
  if (password.length < MIN_PASSWORD_LENGTH) {
    return `Password must be at least ${MIN_PASSWORD_LENGTH} characters.`;
  }
  if (!/[A-Z]/.test(password)) {
    return 'Password must include at least 1 uppercase letter.';
  }
  if (confirmPassword !== undefined && password !== confirmPassword) {
    return 'Passwords do not match.';
  }
  return '';
}

/** Same hints as mosida-web / AI gift-shop auth. Hidden until password typing starts. */
function PasswordRequirementsHints({ password, confirmPassword = '' }) {
  if (!password) return null;

  const hasMinLength = password.length >= MIN_PASSWORD_LENGTH;
  const hasUppercase = /[A-Z]/.test(password);
  const showMatchRule = Boolean(confirmPassword);
  const passwordsMatch =
    showMatchRule && password === confirmPassword && confirmPassword.length > 0;

  const itemClass = (met) =>
    `passwordHints__item${met ? ' is-met' : ' is-unmet'}`;

  return (
    <ul className="passwordHints" aria-live="polite">
      <li className={itemClass(hasMinLength)}>
        At least {MIN_PASSWORD_LENGTH} characters
      </li>
      <li className={itemClass(hasUppercase)}>At least 1 uppercase letter</li>
      {showMatchRule ? (
        <li className={itemClass(passwordsMatch)}>
          {passwordsMatch ? 'Password match' : 'Password does not match'}
        </li>
      ) : null}
    </ul>
  );
}

export default PasswordRequirementsHints;
